import { Pencil } from "lucide-react";
import { ReactNode } from "react";

import { Button } from "../../button";

export function ChoosePencilButton(props: {
  label: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      variant="subtle"
      type="button"
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <span className="flex items-center gap-1">
        {props.label}
        {!props.disabled && <Pencil className="size-4" />}
      </span>
    </Button>
  );
}
